// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/editor/v1/editor.proto" (package "c1.api.editor.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.api.editor.v1.EditorMarker
 */
export interface EditorMarker {
    /**
     * @generated from protobuf field: int32 startLineNumber = 1;
     */
    startLineNumber: number;
    /**
     * @generated from protobuf field: int32 startColumn = 2;
     */
    startColumn: number;
    /**
     * @generated from protobuf field: int32 endLineNumber = 3;
     */
    endLineNumber: number;
    /**
     * @generated from protobuf field: int32 endColumn = 4;
     */
    endColumn: number;
    /**
     * @generated from protobuf field: string message = 5;
     */
    message: string;
    /**
     * @generated from protobuf field: c1.api.editor.v1.EditorMarkerSeverity severity = 6;
     */
    severity: EditorMarkerSeverity;
}
/**
 * @generated from protobuf message c1.api.editor.v1.EditorServiceValidateCELRequest
 */
export interface EditorServiceValidateCELRequest {
    /**
     * @generated from protobuf field: string expression = 1;
     */
    expression: string;
    /**
     * @generated from protobuf field: c1.api.editor.v1.EditorValidationEnv validation_env = 2;
     */
    validationEnv: EditorValidationEnv;
    /**
     * Form field context for FORM_FIELD environment.
     *
     * @generated from protobuf field: c1.api.editor.v1.FormFieldCELContext form_field_context = 3;
     */
    formFieldContext?: FormFieldCELContext;
    /**
     * Workflow context for WORKFLOW_STEP and WORKFLOW_TRIGGER environments.
     *
     * @generated from protobuf field: c1.api.editor.v1.WorkflowCELContext workflow_context = 4;
     */
    workflowContext?: WorkflowCELContext;
}
/**
 * @generated from protobuf message c1.api.editor.v1.EditorServiceValidateCELResponse
 */
export interface EditorServiceValidateCELResponse {
    /**
     * @generated from protobuf field: repeated c1.api.editor.v1.EditorMarker markers = 2;
     */
    markers: EditorMarker[];
}
/**
 * WorkflowCELContext provides context for workflow-related CEL validation.
 * This allows the schema to include step output variables dynamically.
 *
 * @generated from protobuf message c1.api.editor.v1.WorkflowCELContext
 */
export interface WorkflowCELContext {
    /**
     * The trigger type for the workflow (maps to workflow trigger type enum value).
     *
     * @generated from protobuf field: int32 trigger_type = 1;
     */
    triggerType: number;
    /**
     * Names of preceding steps whose outputs are available.
     *
     * @generated from protobuf field: repeated string preceding_step_names = 2;
     */
    precedingStepNames: string[];
    /**
     * The name of the current step being edited.
     *
     * @generated from protobuf field: string current_step_name = 3;
     */
    currentStepName: string;
}
/**
 * FormFieldCELContext provides context for form field CEL validation.
 * This allows the schema to include the fields variable with proper field types.
 *
 * @generated from protobuf message c1.api.editor.v1.FormFieldCELContext
 */
export interface FormFieldCELContext {
    /**
     * The form fields available in this context.
     * Each entry maps field name to its type (e.g., "string", "bool", "list(string)").
     * Type values are not further constrained since they come from FieldToCELType mappings.
     *
     * @generated from protobuf field: map<string, string> field_types = 1;
     */
    fieldTypes: {
        [key: string]: string;
    };
    /**
     * The name of the current field being edited (optional, empty string is valid).
     * When provided, the "value" variable will be typed according to this field's type.
     * When not provided or empty, "value" defaults to string type.
     *
     * @generated from protobuf field: string current_field_name = 2;
     */
    currentFieldName: string;
}
/**
 * @generated from protobuf message c1.api.editor.v1.EditorServiceGetCELSchemaRequest
 */
export interface EditorServiceGetCELSchemaRequest {
    /**
     * The validation environment to get the schema for.
     *
     * @generated from protobuf field: c1.api.editor.v1.EditorValidationEnv validation_env = 1;
     */
    validationEnv: EditorValidationEnv;
    /**
     * Workflow context for WORKFLOW_STEP and WORKFLOW_TRIGGER environments.
     *
     * @generated from protobuf field: c1.api.editor.v1.WorkflowCELContext workflow_context = 2;
     */
    workflowContext?: WorkflowCELContext;
    /**
     * Form field context for FORM_FIELD environment.
     *
     * @generated from protobuf field: c1.api.editor.v1.FormFieldCELContext form_field_context = 3;
     */
    formFieldContext?: FormFieldCELContext;
}
/**
 * @generated from protobuf message c1.api.editor.v1.EditorServiceGetCELSchemaResponse
 */
export interface EditorServiceGetCELSchemaResponse {
    /**
     * Available variables in this CEL environment.
     *
     * @generated from protobuf field: repeated c1.api.editor.v1.CELVariable variables = 1;
     */
    variables: CELVariable[];
    /**
     * Available functions in this CEL environment.
     *
     * @generated from protobuf field: repeated c1.api.editor.v1.CELFunction functions = 2;
     */
    functions: CELFunction[];
    /**
     * Available types in this CEL environment.
     *
     * @generated from protobuf field: repeated c1.api.editor.v1.CELType types = 3;
     */
    types: CELType[];
    /**
     * Available constants in this CEL environment (e.g., TimeFormat.RFC3339).
     *
     * @generated from protobuf field: repeated c1.api.editor.v1.CELConstant constants = 4;
     */
    constants: CELConstant[];
}
/**
 * CELVariable describes a variable available in a CEL environment.
 *
 * @generated from protobuf message c1.api.editor.v1.CELVariable
 */
export interface CELVariable {
    /**
     * The name of the variable (e.g., "subject", "task", "ctx").
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * The type name of the variable (e.g., "c1.user.v1", "c1.task.v1").
     *
     * @generated from protobuf field: string type_name = 2;
     */
    typeName: string;
    /**
     * Human-readable description of the variable.
     *
     * @generated from protobuf field: string description = 3;
     */
    description: string;
}
/**
 * CELFunction describes a function available in a CEL environment.
 *
 * @generated from protobuf message c1.api.editor.v1.CELFunction
 */
export interface CELFunction {
    /**
     * The fully qualified function name (e.g., "c1.user.v1.HasEntitlement").
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Human-readable description of the function.
     *
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * Parameter types in order.
     *
     * @generated from protobuf field: repeated string param_types = 3;
     */
    paramTypes: string[];
    /**
     * Return type of the function.
     *
     * @generated from protobuf field: string return_type = 4;
     */
    returnType: string;
}
/**
 * CELType describes a custom type available in a CEL environment.
 *
 * @generated from protobuf message c1.api.editor.v1.CELType
 */
export interface CELType {
    /**
     * The type name (e.g., "c1.user.v1").
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Human-readable description of the type.
     *
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * Fields available on this type.
     *
     * @generated from protobuf field: repeated c1.api.editor.v1.CELTypeField fields = 3;
     */
    fields: CELTypeField[];
}
/**
 * CELTypeField describes a field on a CEL type.
 *
 * @generated from protobuf message c1.api.editor.v1.CELTypeField
 */
export interface CELTypeField {
    /**
     * The field name (e.g., "email", "department").
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * The type of the field (e.g., "string", "int", "list(string)").
     *
     * @generated from protobuf field: string type_name = 2;
     */
    typeName: string;
    /**
     * Human-readable description of the field.
     *
     * @generated from protobuf field: string description = 3;
     */
    description: string;
}
/**
 * CELConstant describes a constant available in a CEL environment.
 *
 * @generated from protobuf message c1.api.editor.v1.CELConstant
 */
export interface CELConstant {
    /**
     * The constant name (e.g., "TimeFormat.RFC3339").
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * The type of the constant value.
     *
     * @generated from protobuf field: string type_name = 2;
     */
    typeName: string;
    /**
     * The string representation of the value.
     *
     * @generated from protobuf field: string value = 3;
     */
    value: string;
    /**
     * Human-readable description of the constant.
     *
     * @generated from protobuf field: string description = 4;
     */
    description: string;
}
/**
 * @generated from protobuf enum c1.api.editor.v1.EditorMarkerSeverity
 */
export enum EditorMarkerSeverity {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: HINT = 1;
     */
    HINT = 1,
    /**
     * @generated from protobuf enum value: INFO = 2;
     */
    INFO = 2,
    /**
     * @generated from protobuf enum value: WARNING = 4;
     */
    WARNING = 4,
    /**
     * @generated from protobuf enum value: ERROR = 8;
     */
    ERROR = 8
}
/**
 * @generated from protobuf enum c1.api.editor.v1.EditorValidationEnv
 */
export enum EditorValidationEnv {
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_POLICY = 1;
     */
    POLICY = 1,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_DIRECTORY = 2;
     */
    DIRECTORY = 2,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_POLICY_APPROVER = 3;
     */
    POLICY_APPROVER = 3,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_WORKFLOW_STEP = 4;
     */
    WORKFLOW_STEP = 4,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_WORKFLOW_TRIGGER = 5;
     */
    WORKFLOW_TRIGGER = 5,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_PUSH_RULE = 6;
     */
    PUSH_RULE = 6,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_ACCESS_REVIEW_USER = 7;
     */
    ACCESS_REVIEW_USER = 7,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_ACCESS_REVIEW_ACCOUNT = 8;
     */
    ACCESS_REVIEW_ACCOUNT = 8,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_ACCOUNT_PROVISIONING = 9;
     */
    ACCOUNT_PROVISIONING = 9,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_CONNECTOR_TRANSFORM = 10;
     */
    CONNECTOR_TRANSFORM = 10,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_ATTRIBUTE_MAPPING = 11;
     */
    ATTRIBUTE_MAPPING = 11,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_MANAGER_MAPPING = 12;
     */
    MANAGER_MAPPING = 12,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_DIRECTORY_STATUS = 13;
     */
    DIRECTORY_STATUS = 13,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_FORM_FIELD = 14;
     */
    FORM_FIELD = 14,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_DYNAMIC_GROUP_MEMBERSHIP = 15;
     */
    DYNAMIC_GROUP_MEMBERSHIP = 15
}
// @generated message type with reflection information, may provide speed optimized methods
class EditorMarker$Type extends MessageType<EditorMarker> {
    constructor() {
        super("c1.api.editor.v1.EditorMarker", [
            { no: 1, name: "startLineNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "startColumn", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "endLineNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "endColumn", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "severity", kind: "enum", T: () => ["c1.api.editor.v1.EditorMarkerSeverity", EditorMarkerSeverity] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.EditorMarker
 */
export const EditorMarker = new EditorMarker$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditorServiceValidateCELRequest$Type extends MessageType<EditorServiceValidateCELRequest> {
    constructor() {
        super("c1.api.editor.v1.EditorServiceValidateCELRequest", [
            { no: 1, name: "expression", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1048576" } } } },
            { no: 2, name: "validation_env", kind: "enum", T: () => ["c1.api.editor.v1.EditorValidationEnv", EditorValidationEnv, "EDITOR_VALIDATION_ENV_"] },
            { no: 3, name: "form_field_context", kind: "message", T: () => FormFieldCELContext },
            { no: 4, name: "workflow_context", kind: "message", T: () => WorkflowCELContext }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.EditorServiceValidateCELRequest
 */
export const EditorServiceValidateCELRequest = new EditorServiceValidateCELRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditorServiceValidateCELResponse$Type extends MessageType<EditorServiceValidateCELResponse> {
    constructor() {
        super("c1.api.editor.v1.EditorServiceValidateCELResponse", [
            { no: 2, name: "markers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EditorMarker }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.EditorServiceValidateCELResponse
 */
export const EditorServiceValidateCELResponse = new EditorServiceValidateCELResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkflowCELContext$Type extends MessageType<WorkflowCELContext> {
    constructor() {
        super("c1.api.editor.v1.WorkflowCELContext", [
            { no: 1, name: "trigger_type", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "preceding_step_names", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "current_step_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.WorkflowCELContext
 */
export const WorkflowCELContext = new WorkflowCELContext$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormFieldCELContext$Type extends MessageType<FormFieldCELContext> {
    constructor() {
        super("c1.api.editor.v1.FormFieldCELContext", [
            { no: 1, name: "field_types", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "validate.rules": { map: { keys: { string: { minLen: "1" } }, values: { string: { minLen: "1" } } } } } },
            { no: 2, name: "current_field_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.FormFieldCELContext
 */
export const FormFieldCELContext = new FormFieldCELContext$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditorServiceGetCELSchemaRequest$Type extends MessageType<EditorServiceGetCELSchemaRequest> {
    constructor() {
        super("c1.api.editor.v1.EditorServiceGetCELSchemaRequest", [
            { no: 1, name: "validation_env", kind: "enum", T: () => ["c1.api.editor.v1.EditorValidationEnv", EditorValidationEnv, "EDITOR_VALIDATION_ENV_"] },
            { no: 2, name: "workflow_context", kind: "message", T: () => WorkflowCELContext },
            { no: 3, name: "form_field_context", kind: "message", T: () => FormFieldCELContext }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.EditorServiceGetCELSchemaRequest
 */
export const EditorServiceGetCELSchemaRequest = new EditorServiceGetCELSchemaRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditorServiceGetCELSchemaResponse$Type extends MessageType<EditorServiceGetCELSchemaResponse> {
    constructor() {
        super("c1.api.editor.v1.EditorServiceGetCELSchemaResponse", [
            { no: 1, name: "variables", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CELVariable },
            { no: 2, name: "functions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CELFunction },
            { no: 3, name: "types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CELType },
            { no: 4, name: "constants", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CELConstant }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.EditorServiceGetCELSchemaResponse
 */
export const EditorServiceGetCELSchemaResponse = new EditorServiceGetCELSchemaResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CELVariable$Type extends MessageType<CELVariable> {
    constructor() {
        super("c1.api.editor.v1.CELVariable", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.CELVariable
 */
export const CELVariable = new CELVariable$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CELFunction$Type extends MessageType<CELFunction> {
    constructor() {
        super("c1.api.editor.v1.CELFunction", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "param_types", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "return_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.CELFunction
 */
export const CELFunction = new CELFunction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CELType$Type extends MessageType<CELType> {
    constructor() {
        super("c1.api.editor.v1.CELType", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CELTypeField }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.CELType
 */
export const CELType = new CELType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CELTypeField$Type extends MessageType<CELTypeField> {
    constructor() {
        super("c1.api.editor.v1.CELTypeField", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.CELTypeField
 */
export const CELTypeField = new CELTypeField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CELConstant$Type extends MessageType<CELConstant> {
    constructor() {
        super("c1.api.editor.v1.CELConstant", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.CELConstant
 */
export const CELConstant = new CELConstant$Type();
/**
 * @generated ServiceType for protobuf service c1.api.editor.v1.EditorService
 */
export const EditorService = new ServiceType("c1.api.editor.v1.EditorService", [
    { name: "ValidateCEL", options: { "authz.method": { role: "VIEWER" } }, I: EditorServiceValidateCELRequest, O: EditorServiceValidateCELResponse },
    { name: "GetCELSchema", options: { "authz.method": { role: "VIEWER" } }, I: EditorServiceGetCELSchemaRequest, O: EditorServiceGetCELSchemaResponse }
]);
